const EM_DASH = '—'

export function formatRelativeTime(ts: number): string {
  const sec = Math.floor((Date.now() - ts) / 1000)
  if (sec < 60) return 'обновлено только что'
  if (sec < 3600) return `обновлено ${Math.floor(sec / 60)} мин назад`
  if (sec < 86400) return `обновлено ${Math.floor(sec / 3600)} ч назад`
  return `обновлено ${Math.floor(sec / 86400)} дн назад`
}

export function getDefaultShipDate(): string {
  const now = new Date()
  if (now.getHours() >= 15) now.setDate(now.getDate() + 1)
  return now.toISOString().slice(0, 10)
}

export function formatIsoDate(dateStr: string): string {
  if (!dateStr) return EM_DASH
  const d = new Date(dateStr)
  if (isNaN(d.getTime())) return dateStr
  return d.toLocaleDateString('ru-RU', { day: 'numeric', month: 'short', year: '2-digit' })
}

export function formatIsoDateFull(dateStr: string): string {
  if (!dateStr) return EM_DASH
  const d = new Date(dateStr)
  if (isNaN(d.getTime())) return dateStr
  return d.toLocaleDateString('ru-RU', { day: 'numeric', month: 'long', year: 'numeric' })
}

export function calcDeliveryDate(shipDate: string, transitDays: string): string {
  if (!shipDate || !transitDays) return EM_DASH
  const d = new Date(shipDate)
  if (isNaN(d.getTime())) return EM_DASH
  d.setDate(d.getDate() + parseInt(transitDays, 10))
  return d.toLocaleDateString('ru-RU', { day: 'numeric', month: 'long', year: 'numeric' })
}
